import { LangEum, LocalEum } from '@/constant'
import { createContext } from 'react'
import { top1Icon, top2Icon, top3Icon, otherIcon } from './constants'
import langConfigMap from './lang'

const context = createContext({
  currencyCode: 'HK$',
  lang: LangEum.en,
  langConfig: langConfigMap.en,
  editConfig: { local: 'HK' },
  trackHelper: (eventName: string, params: any) => null,
  handleTrack: (position: number, spu_id: number, block_type?: number) => null,
})

export const ProductContext = createContext({
  top1Icon,
  top2Icon,
  top3Icon,
  otherIcon,
  currencyCode: 'HK$',
  local: LocalEum.HK,
  langConfig: langConfigMap.en,
})

export const TypeListContext = createContext<{
  onTypeChange: (key: number, id: number) => void
  lang: LangEum
}>({
  onTypeChange: (key: number, id: number) => {},
  lang: LangEum.en,
})

// 一级Tab菜单数据
export const CategoryListContext = createContext<{
  onCategoryChange: (key: number) => void
  lang: LangEum
}>({
  onCategoryChange: (key: number) => {},
  lang: LangEum.en,
})

export default context
